"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LoadingIntegrations;

var _react = _interopRequireDefault(require("react"));

var _reactSizeme = require("react-sizeme");

var _commonReact = require("@devsta/common-react");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function LoadingIntegrations() {
  return /*#__PURE__*/_react.default.createElement(_reactSizeme.SizeMe, {
    refreshMode: "debounce",
    refreshRate: 32
  }, function (_ref) {
    var width = _ref.size.width;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "share-video-modal__loading-integrations"
    }, width ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_commonReact.ContentLoader, {
      monitorWidth: true,
      height: 100,
      width: 100
    }, /*#__PURE__*/_react.default.createElement("rect", {
      x: "5",
      y: "18",
      width: 60 / width * 100,
      height: "60"
    }), /*#__PURE__*/_react.default.createElement("rect", {
      x: 10 + 60 / width * 100,
      y: "35",
      rx: "2",
      ry: "2",
      width: "30",
      height: "10"
    }), /*#__PURE__*/_react.default.createElement("rect", {
      x: 10 + 60 / width * 100,
      y: "55",
      rx: "2",
      ry: "2",
      width: "20",
      height: "10"
    }), /*#__PURE__*/_react.default.createElement("rect", {
      x: "65",
      y: "35",
      rx: "2",
      ry: "2",
      width: "30",
      height: "35"
    })), /*#__PURE__*/_react.default.createElement(_commonReact.ContentLoader, {
      monitorWidth: true,
      height: 100,
      width: 100
    }, /*#__PURE__*/_react.default.createElement("rect", {
      x: "5",
      y: "18",
      width: 60 / width * 100,
      height: "60"
    }), /*#__PURE__*/_react.default.createElement("rect", {
      x: 10 + 60 / width * 100,
      y: "35",
      rx: "2",
      ry: "2",
      width: "30",
      height: "10"
    }), /*#__PURE__*/_react.default.createElement("rect", {
      x: 10 + 60 / width * 100,
      y: "55",
      rx: "2",
      ry: "2",
      width: "20",
      height: "10"
    }), /*#__PURE__*/_react.default.createElement("rect", {
      x: "65",
      y: "35",
      rx: "2",
      ry: "2",
      width: "30",
      height: "35"
    }))) : null);
  });
}